// workaround to avoid ejecting react app
const shader =  `#version 300 es
precision highp float;
void main() {
}`
export default shader
